<template>
  <div>
    <PageAllow controller="Qacenter" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 标准回复 -->
              <v-btn
                small
                color="primary"
                class="ms-1"
                :href="'/#/qacenter/standard-requests'"
              >
                <!-- <v-icon x-small class="pe-1">fa-plus</v-icon> -->
                {{ $t("Complaint.actions.standard_reply") }}
              </v-btn>
              <!-- 投诉分类 -->
              <v-btn
                small
                color="primary"
                class="ms-1"
                :href="'/#/qacenter/categories'"
              >
                <!-- <v-icon x-small class="pe-1">fa-plus</v-icon> -->
                {{ $t("Complaint.actions.qacenter_category") }}
              </v-btn>
              <!-- 批量结案 -->
              <v-btn
                small
                color="primary"
                @click.stop="batchClose()"
                class="ms-1"
                :disabled="this.showSelected.length ? false : true"
              >
                <!-- <v-icon x-small class="pe-1">fa-plus</v-icon> -->
                {{ $t("Complaint.actions.batch_close") }}
              </v-btn>
              <!-- 批量回复 -->
              <v-btn
                small
                color="primary"
                @click.stop="replyDialog = true"
                class="ms-1"
                :disabled="this.showSelected.length ? false : true"
              >
                <!-- <v-icon x-small class="pe-1">fa-plus</v-icon> -->
                {{ $t("Complaint.actions.batch_reply") }}
              </v-btn>
               <!-- 导出 -->
              <v-btn
                v-if="$permission.permissionAllow('Qacenter', 'export')"
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="ExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("Complaint.export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 流水编号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    v-model="options.question_code"
                    @text="questionCode = $event"
                    :label="$t('Complaint.code')"
                  />
                </v-col>
                <!--分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherQacenterCategory
                    v-model="qacenterSelected"
                    :label="$t('Complaint.category')"
                    :notice="qacenter_categories"
                  />
                </v-col>
                <!-- 门店名字 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    v-model="options.shop_key_word"
                    @text="shopKeyWord = $event"
                    :label="$t('Complaint.shop', [$consts.shopName()])"
                  />
                </v-col>
                <!-- 加盟 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherAlliance
                    v-model="allianceSelected"
                    :label="$t('Complaint.shop', [$consts.allianceName()])"
                  />
                </v-col>
                <!-- 分组 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrict v-model="districtSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Complaint.status.title')"
                    :items="$consts.qacenterStatus"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <div class="mx-4 mb-4">
        <v-data-table
          v-model="showSelected"
          :headers="headers"
          :items="qacenter_questions"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          show-select
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <!-- 查看按钮 -->
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  :href="'/#/qacenter/question-detail/' + item.id"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("Complaint.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("Complaint.detail") }}</span>
            </v-tooltip>
             <!-- 结案按钮 -->
            <v-tooltip top v-if="item.actions.complete">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    Dialog = true;
                    itemId = item.id;
                  "
                >
                  <!-- <v-icon x-small class="pe-1"></v-icon> -->
                  {{ $t("Complaint.close") }}
                </v-btn>
              </template>
              <span>{{ $t("Complaint.close") }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.shop="{ item }">
            <span class="text-no-wrap">
              {{ item.shop ? item.shop.shop_name : "" }}
            </span>
            <br />
            <span class="text-no-wrap caption secondary--text">
              {{ item.shop ? item.shop.shop_code : "" }}
            </span>
          </template>

          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | qacenterColor"
              :text-color="item.status | qacenterTextColor"
            >
              {{ item.status | qacenterText }}
            </v-chip>

            <v-btn
              v-if="item.status !== 0"
              class="mx-2 rounded-circle"
              dark
              fab
              x-small
              depressed
              :color="item.answer_count == 0 ? 'info' : 'danger'"
              :href="'/#/qacenter/question-detail/' + item.id"
            >
              {{ item.answer_count }}
            </v-btn>
          </template>
          <!-- 选择分类 -->
          <template v-slot:item.category="{ item }">
            <span>
              <SearcherQacenterCategory
                unclearable
                v-model="item.qacenter_category"
                @input="input($event, item.id)"
                :notice="qacenter_categories"
                hide-details
                label="请选择"
              />
            </span>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog v-model="Dialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("Complaint.text") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="Dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="Close()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="replyDialog" width="800px">
      <v-card flat>
        <v-card-title class="mx-3">
          {{ $t("Complaint.actions.batch_reply") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="replyDialog = false"
                >fa-times
              </v-icon>
            </template>
            {{ $t("CRUD.backToList", [$t("Complaint.title")]) }}
          </v-tooltip>
        </v-card-title>
        <v-divider />

        <!-- <v-card-text> -->
        <v-container>
          <ValidationObserver ref="observer">
            <v-form>
              <v-row align="center" class="my-1">
                <v-col cols="2">
                  <!-- <span class="d-flex"> -->
                  {{ $t("QuestionDetail.standard_reply") + $t("Global.colon") }}
                  <br />
                  <!-- </span> -->
                </v-col>
                <v-col cols="8">
                  <SearcherStandardRequest @input="inputCategory($event)" />
                </v-col>
              </v-row>
              <v-row align="center" class="my-1">
                <v-col cols="12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('QuestionDetail.text')"
                    rules="required"
                  >
                    <span class="d-flex">
                      <v-textarea
                        v-model="text"
                        :hint="$t('QuestionDetail.text')"
                        outlined
                        auto-grow
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'text')
                            .concat(errors)
                        "
                      />
                    </span>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-container>
        <v-col class="font-weight-bold text-left">
          {{ $t("Complaint.selected_complaints") }}
        </v-col>
        <div class="mx-4 mb-4">
          <v-data-table
            v-model="showSelected"
            :headers="headers_dialog"
            :items="replyItem"
            multi-sort
            show-select
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.shop="{ item }">
              <span class="text-no-wrap">
                {{ item.shop ? item.shop.shop_name : "" }}
              </span>
              <br />
              <span class="text-no-wrap caption secondary--text">
                {{ item.shop ? item.shop.shop_code : "" }}
              </span>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.status | qacenterColor"
                :text-color="item.status | qacenterTextColor"
              >
                {{ item.status | qacenterText }}
              </v-chip>
            </template>
          </v-data-table>
        </div>
        <!-- </v-card-text> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="replyDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="batchReply()">{{
            $t("CRUD.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Qacenter from "@/api/qacenter.js";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import SearcherAlliance from "@/components/plugins/SearcherAlliance";
import SearcherQacenterCategory from "@/components/plugins/SearcherQacenterCategory";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherStandardRequest from "@/components/plugins/SearcherStandardRequest";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  district_ids: [],
  agent_ids: [],
  category_codes: [],
  status: [0, 1, 2],
  question_code: "",
  shop_key_word: "",
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("qacenter-options")
        ? sessionStorage.getItem("qacenter-options")
        : JSON.stringify(defaultOptions)
    ),
    districtSelected: null,
    allianceSelected: null,
    qacenter_questions: [],
    replyItem: [],
    paging: {},
    qacenterSelected: null,
    Dialog: false,
    replyDialog: false,
    itemId: null,
    showSelected: [],
    serverErrors: [],
    text: "",
    qacenter_categories: [],
    qacenter_category: {},
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherDistrict,
    SearcherAlliance,
    SearcherQacenterCategory,
    SearcherStatus,
    SearcherStandardRequest,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    // notice(){
    //   return this.qacenter_categories
    // },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.customerMaintenance"),
        disabled: false,
        href: "/qacenter",
      },
      {
        text: i18n.t("Complaint.title"),
        disabled: true,
        href: "/qacenter",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("AccountLogs.date"),
      },
    ],
    headers() {
      return [
        // {
        //   text: i18n.t("Complaint.Fields.idx"),
        //   align: "start",
        //   sortable: false,
        //   value: "idx",
        // },
        {
          text: i18n.t("Complaint.Fields.question_code"),
          align: "start",
          sortable: false,
          value: "question_code",
        },
        {
          text: this.$consts.shopName(),
          align: "start",
          sortable: false,
          value: "shop",
        },
        {
          text: i18n.t("Complaint.Fields.title"),
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: i18n.t("Complaint.Fields.category"),
          align: "start",
          sortable: false,
          value: "category",
        },
        {
          text: i18n.t("Complaint.Fields.created"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("Complaint.Fields.status"),
          align: "start",
          sortable: false,
          width: "160px",
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    headers_dialog() {
      return [
        {
          text: i18n.t("Complaint.Fields.question_code"),
          align: "start",
          sortable: false,
          value: "question_code",
        },
        {
          text: i18n.t("Complaint.Fields.shop"),
          align: "start",
          sortable: false,
          value: "shop",
        },
        {
          text: i18n.t("Complaint.Fields.title"),
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: i18n.t("Complaint.Fields.created"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("Complaint.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
      ];
    },

    ...mapState(["loading"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("qacenter", [
        "allianceSelected",
        "districtSelected",
        "qacenterSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "districtSelected":
                this.districtSelected = selected.value;
                break;
              case "allianceSelected":
                this.allianceSelected = selected.value;
                break;
              case "qacenterSelected":
                this.qacenterSelected = selected.value;
            }
          });
        }.bind(this)
      );

    Qacenter.tree()
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.qacenter_categories = response.data.qacenter_categories;
          }
          // this.loading = false;
        }.bind(this)
      )
      .catch(
        function () {
          // this.loading = false;
        }.bind(this)
      );
  },

  methods: {
    input(e, id) {
      if (id) {
        if (e) {
          var data = [];
          data.push({
            category_id: e.id,
          });
          Qacenter.edit(id, data[0]).then(
            function (response) {
              if (response.data.status.isOK()) {
                // this.$snackbar.success(i18n.t("Complaint.category_text"));
              }
            }.bind(this)
          );
        }
      }
    },
    inputCategory(e) {
      if (e !== null) {
        this.text = e.title;
      } else {
        this.text = "";
      }
    },

    Close() {
      //结案
      Qacenter.complete(this.itemId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getQacenterFromAPI();
          }
          this.Dialog = false;
        }.bind(this)
      );
    },

    onSearch() {
      this.options = Object.assign({}, this.options, {
        question_code: this.questionCode,
        shop_key_word: this.shopKeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.districtSelected = null;
      this.allianceSelected = null;
      this.qacenterSelected = null;
    },

    getQacenterFromAPI() {
      Qacenter.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.qacenter_questions = response.data.qacenter_questions;
            // console.log(this.qacenter_questions);
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    // 封装的一个数据格式转换 用于批量结案请求参数
    arrToObj(arr) {
      const obj = {};
      arr.forEach((e) => {
        for (const key in e) {
          if (!obj[key]) {
            obj[key] = [e[key]];
          } else {
            obj[key].push(e[key]);
          }
        }
      });
      return obj;
    },

    batchClose() {
      if (this.showSelected.length) {
        let data = [];
        // let closeData = []
        this.showSelected.map((e) => {
          data.push({ ids: e.id });
        });
        // data.map((e)=>{
        //     closeData.push(e.id)
        // })
        // console.log({id:closeData});
        Qacenter.batchComplete(this.arrToObj(data)).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getQacenterFromAPI();
              window.location.reload(true); //刷新页面
            }
          }.bind(this)
        );
      }
    },

    batchReply() {
      if (this.showSelected.length) {
        let data = [];
        this.showSelected.map((e) => {
          data.push({ ids: e.id });
        });

        Qacenter.batchRequest(
          Object.assign({}, this.arrToObj(data), { answer: this.text })
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getQacenterFromAPI();
              window.location.reload(true); //刷新页面
            }
            this.replyDialog = false;
          }.bind(this)
        );
      }
    },
    ExportExcel(){
      Qacenter.exports(this.options)
    }
  },
  watch: {
    showSelected: {
      handler() {
        this.replyItem = this.showSelected;
        // console.log(this.replyItem);
      },
    },
    options: {
      deep: true,
      handler() {
        this.getQacenterFromAPI();
        sessionStorage.setItem(
          "qacenter-options",
          JSON.stringify(this.options)
        );
      },
    },

    districtSelected: {
      handler() {
        this.options.district_ids = this.districtSelected
          ? [this.districtSelected.id]
          : "";
        sessionStorage.setItem(
          "qacenter-districtSelected",
          JSON.stringify(this.districtSelected)
        );
      },
    },
    allianceSelected: {
      handler() {
        this.options.agent_ids = this.allianceSelected
          ? [this.allianceSelected.id]
          : "";
        sessionStorage.setItem(
          "qacenter-allianceSelected",
          JSON.stringify(this.allianceSelected)
        );
      },
    },
    qacenterSelected: {
      handler() {
        this.options.category_codes = this.qacenterSelected
          ? [this.qacenterSelected.code]
          : "";
        sessionStorage.setItem(
          "qacenter-qacenterSelected",
          JSON.stringify(this.qacenterSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>